var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/pie-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.28 21.1867C27.4318 23.1926 26.105 24.9603 24.4158 26.3351C22.7266 27.7098 20.7264 28.6499 18.5899 29.073C16.4535 29.4962 14.2459 29.3895 12.1602 28.7624C10.0745 28.1353 8.17417 27.0068 6.62536 25.4755C5.07655 23.9443 3.92642 22.057 3.27551 19.9786C2.62461 17.9002 2.49275 15.694 2.89146 13.5528C3.29018 11.4117 4.20733 9.40084 5.56273 7.69604C6.91813 5.99124 8.67051 4.64442 10.6667 3.77333",
    stroke: "#002E19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.3333 16C29.3333 14.249 28.9885 12.5152 28.3184 10.8976C27.6483 9.27988 26.6662 7.81002 25.4281 6.57191C24.19 5.3338 22.7201 4.35167 21.1024 3.68161C19.4848 3.01154 17.751 2.66667 16 2.66667V16H29.3333Z",
    stroke: "#002E19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonPie);
export default __webpack_public_path__ + "static/media/lesson-pie.cef6b9595299d69e36bbed76b821ff50.svg";
export { ForwardRef as ReactComponent };